export default "__VITE_ASSET__CM3$c3OO__"